import { 
  ReactNode,
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react'
import { ChatAgentHook, useChatAgent } from '../hook/useChatAgent'

export const ChatContext = createContext<ChatAgentHook | undefined>(undefined)

export const useChatContext = () => {
  const ctx = useContext(ChatContext)
  if (!ctx)
    throw new Error('No ChatContext.Provider found when calling useChatContext.')
  return ctx
}

type Props = {
  children: ReactNode,
}

export const ChatContextProvider = ({ children }: Props) => {
  const {
    messages,
    hasError,
    sendMessage,
    isChatLoading,
    resetChat,
    stopMessage
  } = useChatAgent()

  const [isThinking, setIsThinking] = useState(false)
  const [thinkingTime, setThinkingTime] = useState(0)

  const lastThinkingTimeRef = useRef(0)

useEffect(() => {
  let timer: any = null

  if (isChatLoading) {
    // Start thinking
    setIsThinking(true)
    setThinkingTime(0)
    lastThinkingTimeRef.current = 0

    timer = setInterval(() => {
      lastThinkingTimeRef.current += 1
      setThinkingTime((prev) => prev + 1)
    }, 1000)
  } else {
    // Stop thinking, but keep the final thinkingTime
    setIsThinking(false)
    // timer cleared below
  }

  return () => {
    if (timer) clearInterval(timer)
  }
}, [isChatLoading])


  return (
    <ChatContext.Provider
      value={{
        messages,
        hasError,
        sendMessage,
        isChatLoading,
        resetChat,
        stopMessage,
        isThinking,
        thinkingTime,
      }}
    >
      {children}
    </ChatContext.Provider>
  )
}
